/**
 * Logger 工具
 * 根據環境變數 REACT_APP_ENABLE_CONSOLE_LOG 決定是否輸出 console log
 * 
 * 使用方式：
 * import logger from './utils/logger';
 * logger.log('訊息');
 * logger.warn('警告');
 * logger.error('錯誤');
 * 
 * 環境變數設置：
 * - REACT_APP_ENABLE_CONSOLE_LOG=true (開發環境，顯示所有 log)
 * - REACT_APP_ENABLE_CONSOLE_LOG=false (生產環境，隱藏所有 log)
 * - 未設置時，預設在開發環境顯示，生產環境隱藏
 */

// 檢查是否啟用 console log
const isConsoleEnabled = () => {
  // 如果明確設置了環境變數，使用該值
  const envValue = process.env.REACT_APP_ENABLE_CONSOLE_LOG;
  if (envValue !== undefined) {
    return envValue === 'true' || envValue === '1';
  }
  
  // 如果沒有設置，預設在開發環境啟用，生產環境禁用
  return process.env.NODE_ENV === 'development';
};

const enabled = isConsoleEnabled();

// 創建 logger 對象
const logger = {
  log: enabled ? console.log.bind(console) : () => {},
  warn: enabled ? console.warn.bind(console) : () => {},
  error: enabled ? console.error.bind(console) : () => {},
  info: enabled ? console.info.bind(console) : () => {},
  debug: enabled ? console.debug.bind(console) : () => {},
  table: enabled ? console.table.bind(console) : () => {},
  group: enabled ? console.group.bind(console) : () => {},
  groupEnd: enabled ? console.groupEnd.bind(console) : () => {},
  groupCollapsed: enabled ? console.groupCollapsed.bind(console) : () => {},
  time: enabled ? console.time.bind(console) : () => {},
  timeEnd: enabled ? console.timeEnd.bind(console) : () => {},
};

// 導出 logger
export default logger;

// 檢查是否也禁用 console.error（預設保留錯誤日誌）
const disableErrorLog = process.env.REACT_APP_DISABLE_ERROR_LOG === 'true' || process.env.REACT_APP_DISABLE_ERROR_LOG === '1';

// 可選：覆蓋全局 console（謹慎使用，可能影響第三方庫）
export const overrideGlobalConsole = () => {
  if (!enabled) {
    // 保存原始 console 方法（如果需要）
    window.__originalConsole = {
      log: console.log,
      warn: console.warn,
      error: console.error,
      info: console.info,
      debug: console.debug,
    };
    
    // 覆蓋 console 方法
    console.log = () => {};
    console.warn = () => {};
    console.info = () => {};
    console.debug = () => {};
    
    // 根據環境變數決定是否也禁用 console.error
    if (disableErrorLog) {
      console.error = () => {};
    }
    // 預設保留 console.error，因為錯誤日誌通常需要保留
  }
};
